export default __webpack_public_path__ + "static/og_deriv-7765b1f93af49430017646938596af4f.png";